import React from "react";
import BaseLayout from "../../components/Layout";
import { RptAlertaLista } from "../../components/Relatorios/RptAlertaLista";
import SelectTypeReport from "../../components/Relatorios/SelectTypeReport";
import { AlertTriangle, Store } from "lucide-react";
import "./styles.scss";

type TabKey = "alertas" | "porLoja";

const TABS: {
  key: TabKey;
  label: string;
  description: string;
  Icon: React.FC<React.SVGProps<SVGSVGElement>>;
}[] = [
  {
    key: "alertas",
    label: "Alertas de Monitoramento",
    description:
      "Consulte alertas gerados pelos equipamentos e baixe o relatório em PDF ou Excel.",
    Icon: AlertTriangle,
  },
  {
    key: "porLoja",
    label: "Relatórios por Loja",
    description:
      "Panorama, configuração e histórico dos dispositivos de uma loja específica.",
    Icon: Store,
  },
];

const PageRelatorios = () => {
  const [activeTab, setActiveTab] = React.useState<TabKey>("alertas");
  const active = TABS.find((tab) => tab.key === activeTab)!;

  return (
    <BaseLayout>
      <div className="container relatorios-page">
        <header className="relatorios-page__header">
          <h1 className="heading--lg">Central de Relatórios</h1>
          <p className="relatorios-page__subtitle">
            Escolha abaixo o tipo de relatório que você quer consultar. Depois
            é só preencher os filtros — período, loja ou regional — e clicar
            para visualizar ou baixar.
          </p>
        </header>

        <nav
          className="relatorios-tabs"
          role="tablist"
          aria-label="Tipos de relatório"
        >
          {TABS.map((tab) => {
            const isActive = tab.key === activeTab;
            return (
              <button
                key={tab.key}
                type="button"
                role="tab"
                aria-selected={isActive}
                className={`relatorios-tabs__item ${isActive ? "is-active" : ""}`}
                onClick={() => setActiveTab(tab.key)}
              >
                <tab.Icon className="relatorios-tabs__icon" style={{ width: 18, height: 18 }} />
                <span className="relatorios-tabs__label">{tab.label}</span>
              </button>
            );
          })}
        </nav>

        <p className="relatorios-tabs__description">{active.description}</p>

        <section className="relatorios-page__content">
          {activeTab === "alertas" && <RptAlertaLista />}
          {activeTab === "porLoja" && <SelectTypeReport />}
        </section>
      </div>
    </BaseLayout>
  );
};

export default PageRelatorios;